// extracted by mini-css-extract-plugin
module.exports = {"title":"_6f25b66c20--title--2hNi1","description":"_6f25b66c20--description--1BWNM"};